/* Walldrip theme behaviour. No dependencies. */
(function(){
  var ACCENT='#D13A22', INK='#141414', PAPER='#FBFAF8';
  var calm=function(){return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);};

  /* Scroll reveal. Elements that come into view in the same frame (a row of
     cards, a grid of tiles) get a 70ms step between them, capped at five steps,
     so a row settles in one after another instead of all at once. The delay is
     cleared once the transition has played, so hover transitions stay instant. */
  var reveal=function(){
    if(!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(es){
      var step=0;
      es.forEach(function(e){
        if(!e.isIntersecting)return;
        var el=e.target;
        el.style.setProperty('--wd-delay',(Math.min(step,5)*70)+'ms');
        step++;
        el.classList.add('wd-in');
        io.unobserve(el);
        setTimeout(function(){el.style.removeProperty('--wd-delay');},1200);
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    document.querySelectorAll('[data-reveal]:not(.wd-in)').forEach(function(el){io.observe(el);});
  };
  document.addEventListener('DOMContentLoaded',reveal);
  document.addEventListener('shopify:section:load',reveal);

  /* countdown to a weekly deadline */
  function tick(){
    document.querySelectorAll('[data-countdown]').forEach(function(el){
      var day=parseInt(el.getAttribute('data-weekday')||'0',10);
      var hm=(el.getAttribute('data-time')||'23:59').split(':');
      var now=new Date();
      var t=new Date(now.getTime());
      t.setDate(now.getDate()+((day-now.getDay()+7)%7));
      t.setHours(parseInt(hm[0],10),parseInt(hm[1],10),0,0);
      if(t<=now)t.setDate(t.getDate()+7);
      var ms=t-now;if(ms<0)ms=0;
      var d=Math.floor(ms/864e5),h=Math.floor(ms/36e5)%24,m=Math.floor(ms/6e4)%60,s=Math.floor(ms/1e3)%60;
      var p=function(n){return String(n).padStart(2,'0');};
      el.textContent=(d>0?d+'d ':'')+p(h)+':'+p(m)+':'+p(s);
    });
  }
  tick();setInterval(tick,1000);

  /* cart drawer. Opens by sliding in from the right; closing plays the reverse
     for 220ms before the drawer is hidden (instantly for reduced motion). */
  var closeTimer=null;
  function drawer(){return document.getElementById('wd-drawer');}
  function openDrawer(){
    var d=drawer();if(!d)return;
    if(closeTimer){clearTimeout(closeTimer);closeTimer=null;d.classList.remove('is-closing');}
    if(d.hasAttribute('open'))return;
    d.setAttribute('open','');document.body.classList.add('wd-lock');
    var c=d.querySelector('[data-drawer-close]');c&&c.focus();
  }
  function closeDrawer(){
    var d=drawer();if(!d||!d.hasAttribute('open')||closeTimer)return;
    var done=function(){closeTimer=null;d.classList.remove('is-closing');d.removeAttribute('open');document.body.classList.remove('wd-lock');};
    if(calm()){done();return;}
    d.classList.add('is-closing');
    closeTimer=setTimeout(done,220);
  }
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-cart-open]');if(o){e.preventDefault();openDrawer();return;}
    if(e.target.closest('[data-drawer-close]')||e.target.closest('[data-drawer-scrim]')){e.preventDefault();closeDrawer();}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});

  /* While the cart is updating, dim the drawer so a second tap cannot race the first. */
  function busy(on){
    document.querySelectorAll('[data-cart-section="cart-drawer"]').forEach(function(el){el.classList.toggle('is-busy',!!on);});
  }

  /* Small bump on the cart count after something was added. */
  function bump(){
    if(calm())return;
    document.querySelectorAll('[data-cart-section="cart-icon-bubble"]').forEach(function(b){
      b.classList.remove('wd-bump');void b.offsetWidth;b.classList.add('wd-bump');
    });
  }

  /* refresh cart surfaces via the Section Rendering API */
  function refresh(){
    var ids=[];
    document.querySelectorAll('[data-cart-section]').forEach(function(el){
      var id=el.getAttribute('data-cart-section');if(ids.indexOf(id)<0)ids.push(id);
    });
    if(!ids.length){location.reload();return Promise.resolve();}
    return fetch(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root+'?sections='+ids.join(','):'/?sections='+ids.join(','))
      .then(function(r){return r.json();})
      .then(function(data){
        Object.keys(data).forEach(function(id){
          document.querySelectorAll('[data-cart-section="'+id+'"]').forEach(function(el){
            var doc=new DOMParser().parseFromString(data[id],'text/html');
            var next=doc.querySelector('[data-cart-section="'+id+'"]');
            if(next)el.innerHTML=next.innerHTML;
          });
        });
        var live=document.getElementById('wd-cart-live');if(live)live.textContent='Cart updated';
      }).catch(function(){location.reload();});
  }

  function post(url,body){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
  }

  /* CRO: size pills on product cards.
     Picking a size retargets that card's add button at the matching variant and
     restates both the card price and the button price, so the card, the button
     and the cart always agree. Two taps from grid to cart.

     A pill rests in the accent and goes black once chosen. Painted with explicit
     inline styles rather than left to an [aria-pressed] CSS rule: a transitioned
     property can keep reporting its old colour when the state flips by
     attribute. This is the same approach the product page uses. */
  function paintPill(b,on){
    b.setAttribute('aria-pressed',on?'true':'false');
    b.style.borderColor=on?INK:ACCENT;
    b.style.backgroundColor=on?INK:ACCENT;
    b.style.color=PAPER;
  }

  document.addEventListener('click',function(e){
    var pill=e.target.closest('[data-wd-card-size]');
    if(!pill)return;
    e.preventDefault();
    var card=pill.closest('[data-wd-card]');
    if(!card)return;

    card.querySelectorAll('[data-wd-card-size]').forEach(function(b){paintPill(b,b===pill);});

    var price=pill.getAttribute('data-price')||'';
    var compare=pill.getAttribute('data-compare')||'';

    var now=card.querySelector('[data-wd-card-now]');
    if(now)now.textContent=price;
    var cmp=card.querySelector('[data-wd-card-compare]');
    if(cmp){cmp.textContent=compare;cmp.hidden=!compare;}

    var add=card.querySelector('[data-wd-card-add]');
    if(!add)return;
    var vid=pill.getAttribute('data-vid');
    if(vid)add.setAttribute('data-quick-add',vid);
    var lbl=add.querySelector('[data-wd-card-add-label]');
    if(lbl)lbl.textContent=(add.getAttribute('data-add-label')||'Add')+' — '+price;
    add.classList.remove('is-done');
    add.style.backgroundColor='';
  });

  /* brief confirmation on a card add button */
  function flash(btn){
    btn.disabled=false;
    var lbl=btn.querySelector('[data-wd-card-add-label]');
    if(!lbl)return;
    var prev=lbl.textContent;
    lbl.textContent=btn.getAttribute('data-done-label')||'Added';
    btn.classList.add('is-done');
    btn.style.backgroundColor=INK;
    setTimeout(function(){
      lbl.textContent=prev;
      btn.classList.remove('is-done');
      btn.style.backgroundColor='';
    },1600);
  }

  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-qty]');
    if(q){
      e.preventDefault();
      /* minus at quantity 1 removes the line. Never clamp to 1 - that trapped items in the cart. */
      var line=q.getAttribute('data-line'),d=parseInt(q.getAttribute('data-qty'),10);
      var cur=parseInt(q.getAttribute('data-current'),10);
      var next=Math.max(0,cur+d);
      busy(true);
      post('/cart/change.js',{line:parseInt(line,10),quantity:next}).then(refresh).then(function(){busy(false);},function(){busy(false);});
      return;
    }
    var rm=e.target.closest('[data-remove-line]');
    if(rm){
      e.preventDefault();
      busy(true);
      post('/cart/change.js',{line:parseInt(rm.getAttribute('data-remove-line'),10),quantity:0}).then(refresh).then(function(){busy(false);},function(){busy(false);});
      return;
    }
    var add=e.target.closest('[data-quick-add]');
    if(add){
      e.preventDefault();
      if(add.disabled)return;
      add.disabled=true;
      busy(true);
      post('/cart/add.js',{items:[{id:parseInt(add.getAttribute('data-quick-add'),10),quantity:1}]})
        .then(refresh)
        .then(function(){busy(false);bump();openDrawer();flash(add);})
        .catch(function(){busy(false);add.disabled=false;});
      return;
    }
    var help=e.target.closest('[data-helper-toggle]');
    if(help){e.preventDefault();var p=document.getElementById('wd-size-helper');if(p)p.hidden=!p.hidden;}
  });

  /* product form: ajax add, then open the drawer.
     While the request runs the button reads "Adding…" and ignores further
     taps, so a double tap cannot add the print twice.
     The accelerated checkout button is not a normal submit, so it bypasses this
     and goes straight to checkout - which is the point. */
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-product-form]');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('[data-atc]');
    if(btn&&btn.getAttribute('aria-busy')==='true')return;
    var lbl=btn&&btn.querySelector('[data-atc-label]');
    var prev=lbl?lbl.textContent:'';
    if(btn){
      btn.setAttribute('aria-busy','true');
      btn.disabled=true;
      if(lbl)lbl.textContent=(window.wdStrings&&window.wdStrings.adding)||'Adding…';
    }
    var done=function(){
      if(!btn)return;
      btn.removeAttribute('aria-busy');
      btn.disabled=false;
      if(lbl)lbl.textContent=prev;
    };
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r;})
      .then(refresh)
      .then(function(){done();bump();openDrawer();})
      .catch(done);
  });

  /* product gallery */
  document.addEventListener('click',function(e){
    var g=e.target.closest('[data-shot]');if(!g)return;
    e.preventDefault();
    var root=g.closest('[data-gallery]');if(!root)return;
    var slides=root.querySelectorAll('[data-slide]'),thumbs=root.querySelectorAll('[data-shot][data-index]');
    var cur=parseInt(root.getAttribute('data-index')||'0',10),n=slides.length;
    var v=g.getAttribute('data-shot');
    var next=v==='prev'?(cur+n-1)%n:v==='next'?(cur+1)%n:parseInt(g.getAttribute('data-index'),10);
    root.setAttribute('data-index',next);
    slides.forEach(function(s,i){s.hidden=i!==next;});
    thumbs.forEach(function(t,i){t.style.borderColor=i===next?INK:'transparent';});
    var cap=root.querySelector('[data-caption]');
    if(cap)cap.textContent=slides[next].getAttribute('data-label')||'';
    /* a lazily loaded slide that is being revealed should fetch now */
    var img=slides[next].querySelector('img[loading="lazy"]');
    if(img)img.setAttribute('loading','eager');
  });
})();
